import { normalizeHexColor } from '@/editor/colors'

export const DEFAULT_PARAM_COLOR = '#ffffff'
export const TRANSFORM_PARAM_COLOR = '#00ffff'
export const OPACITY_PARAM_COLOR = '#ffff00'
export const VOLUME_PARAM_COLOR = '#00ff00'

export function normalizeParamColor(color) {
  return normalizeHexColor(color, DEFAULT_PARAM_COLOR)
}

export function canonicalParamColorCode(code) {
  const raw = `${code || ''}`.trim()
  if (!raw) return ''
  return raw
}

export function defaultParamColorForCode(code) {
  const key = canonicalParamColorCode(code)
  if (!key) return DEFAULT_PARAM_COLOR

  if (
    key === 'position' ||
    key.startsWith('position.') ||
    key === 'scale' ||
    key.startsWith('scale.') ||
    key === 'rotation' ||
    key.startsWith('rotation.') ||
    key === 'transform'
  ) {
    return TRANSFORM_PARAM_COLOR
  }

  if (key === 'opacity') return OPACITY_PARAM_COLOR
  if (key === 'volume') return VOLUME_PARAM_COLOR

  return DEFAULT_PARAM_COLOR
}

export function resolveParamColor(colors, code, fallback = DEFAULT_PARAM_COLOR) {
  const key = canonicalParamColorCode(code)
  if (!key) return normalizeParamColor(fallback)
  const map = colors && typeof colors === 'object' ? colors : {}
  return normalizeParamColor(map[key] || fallback)
}
